import Login from "@/components/Login"
export const routes = [
    {
        path: '/',
        redirect: '/login'
    },

    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            title: '登录',
            keepalive: true,
            requireAuth: true,

        }
    },
    {
        path: '/entrypage',
        name: 'entrypage',
        component: () => import('@/components/common/Home.vue'),
        meta: {
            keepalive: true,
            requireAuth: true
        },
        children: [
            {
                path: '/Preson',
                name: 'Preson',
                component: () => import('@/views/PersonWork'),
                meta: {
                    title: '个人日工作',
                    keepalive: true,
                }
            },
            {
                path: '/PersonOvertime',
                name: 'PersonOvertime',
                component: () => import('@/views/PersonOverTime'),
                meta: {
                    title: '个人加班',
                    keepalive: true,
                }
            },
            {
                path: '/departwork',
                name: 'departwork',
                component: () => import('@/components/departwork.vue'),
                meta: {
                    title: '部门日工作',
                    keepalive: true,
                }
            },
            {
                path: '/departovertime',
                name: 'departovertime',
                component: () => import('@/components/departovertime.vue'),
                meta: {
                    title: '部门加班',
                    keepalive: true,
                }
            },
            {
                path: '/Examine',
                name: 'Examine',
                component: () => import('@/views/Examine'),
                meta: {
                    title: '加班审批',
                    keepalive: true,
                }
            },
            {
                path: '/rest',
                name: 'Rest',
                component: () => import('@/views/rest'),
                meta: {
                    title: '调休审批',
                    keepalive: true,
                }
            },
            {
                path: '/AChangepasswrod',
                name: 'AChangepasswrod',
                component: () => import('@/components/a-changepasswrod.vue'),
                meta: {
                    title: '修改密码',
                    keepalive: true,
                }
            },
            {
                path: '/Explain',
                name: 'Explain',
                component: () => import('@/components/explain.vue'),
                meta: {
                    title: '使用说明',
                    keepalive: true,
                }
            },
            {
                path: '/todolist',
                name: 'Todolist',
                component: () => import('@/views/todolist'),
                meta: {
                    title: '待办事项',
                    keepalive: true,
                }
            },
            {
                name: 'gr',
                path: '/gr',
                component: () => import('@/views/KpiTime'),
                meta: {
                    title: '加班详情',
                    keepalive: true,
                }
            },
            {
                path: '/porjectProgress',
                name: 'porjectProgress',
                component: () => import('@/views/porjectProgress'),
                meta: {
                    title: '项目进度',
                    keepalive: true,
                }
            },
            {
                path: '/workplan',
                name: 'workplan',
                component: () => import('@/views/workplan'),
                meta: {
                    title: '工作安排',
                    keepalive: true,
                }
            },
            {
                path: '/tuozhuai',
                name: 'tuozhuai',
                component: () => import('@/views/tuozhuai'),
                meta: {
                    title: '项目拖拽排序',
                    keepalive: true,
                }
            },
            {
                path: '/tishiZujian',
                name: 'tishiZujian',
                component: () => import('@/views/tishiZujian'),
                meta: {
                    title: '弹框选人组件',
                    keepalive: true,
                }
            },
            {
                path: '/zgs',
                name: 'zgs',
                component: () => import('@/views/zgs'),
                meta: {
                    title: '项目总工时',
                    keepalive: true,
                }
            },
            {
                path: '/allKpi',
                name: 'allKpi',
                component: () => import('@/views/allKpiTime'),
                meta: {
                    title: '总Kpi',
                    keepalive: true,
                }
            },
            {
                path: '/xmbg',
                name: 'xmbg',
                component: () => import('@/views/xmbg'),
                meta: {
                    keepalive: true,
                    requireAuth: true,
                    title: '项目任务分配',
                    icon: 'tree',
                }
            },
            {
                path: '/rwperson',
                name: 'rwperson',
                component: () => import('@/views/rwperson'),
                meta: {
                    keepalive: true,
                    requireAuth: true,
                    title: '个人任务',
                    icon: 'tree',
                }
            },
            {
                path: '/qx',
                name: 'qx',
                component: () => import('@/views/qxfenpei'),
                meta: {
                    keepalive: true,
                    requireAuth: true,
                    title: '分配项目授权',
                    icon: 'tree',
                }
            },
            
            {
                path: '/Xinrenwu',
                name: 'Xinrenwu',
                component: () => import('@/views/Xinrenwu'),
                meta: {
                    keepalive: true,
                    requireAuth: true,
                    title: '周项目分配',
                    icon: 'tree',
                }
            },
            {
                path: '/kanrenwu',
                name: 'kanrenwu',
                component: () => import('@/views/Xinrenwu/zhanshi'),
                meta: {
                    keepalive: true,
                    requireAuth: true,
                    title: '周项目任务查看',
                    icon: 'tree',
                }
            },

        ]
    },


    {
        path: '/todolist',
        name: 'todolist',
        component: () => import('@/views/todolist'),
        meta: {
            title: 'todolist',
        }
    },

    // { path: '*', redirect: '/404', hidden: true }
]


// WEBPACK FOOTER //
// ./src/router/router.js